import { Controller } from '@hotwired/stimulus'

export default class InputCurrencyController extends Controller {
  static targets = ['input', 'button'];

  static values = {
    currency: Number,
  };

  connect() {
    this.resizeInput();
  }

  formatInput(_event) {
    this.inputTarget.value = this.inputTarget.value.replace(/[^0-9]/g, '');
  }

  updateInputValue(event) {
    this.selectedButton = event.currentTarget;
    this.inputTarget.value = this.selectedButton.dataset.value;
    this.resizeInput();
    var event = new Event('updateAmountInputValue', {bubbles: true});
    this.element.dispatchEvent(event);
  }

  focusInput() {
    this.inputTarget.value = null;
    this.inputTarget.focus();
    var event = new Event('updateAmountInputValue', {bubbles: true});
    this.element.dispatchEvent(event);
  }

  resizeInput() {
    this.inputTarget.size = this.inputTarget.value.length || 1;
  }
}
